import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCallbackCall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" {...props}>
    <path
      fill="none"
      stroke="#919499"
      strokeLinejoin="round"
      d="M7.125 2.393 12.333 1 9.208 6.571 14 5.286 5.667 16l2.5-6.429L4 10.643z"
    />
  </svg>
);
const Memo = memo(SvgCallbackCall);
export default Memo;
